import { EventEmitter } from 'events';

// enum Events {
//     SignIn,
// }

// export default { eventBus, Events };

const eventBus = new EventEmitter();
// ee.on('message', function (text) {
//   console.log(text)
// });
// ee.emit('message', 'hello world');

export default eventBus;
